export const formatNumberWithCommas = (num, toFixedLength = null) => {
  if (isNaN(num) || num === null) {
    return num;
  }

  // convert to a string so we can split it on the decimal
  const numSplit = num.toString().split('.');

  const leftSide = numSplit[0]; // getting all numbers left of the decimal
  const rightSide = numSplit[1]; // getting all numbers right of the decimal

  const formattedLeftSide = leftSide
    .split('')
    .reverse()
    .map((char, charIdx) => (charIdx && charIdx % 3 === 0 ? char + ',' : char))
    .reverse()
    .join('');

  let formattedRightSide = '';

  if (toFixedLength !== null) {
    for (let i = 0; i < toFixedLength; i++) {
      formattedRightSide += `${!!rightSide && rightSide[i] != undefined ? rightSide[i] : 0}`;
    }
  }

  return !!formattedRightSide ? `${formattedLeftSide}.${formattedRightSide}` : formattedLeftSide;
};

/**
 *
 * @param {*} value any value
 * @returns a parsed value or null (if null, the number is not valid)
 */
export const parseNumberInputValue = (value, toFixedLength = null, maxPlacesToRight = null) => {
  let parsedValue;

  if (!value.toString().length) {
    parsedValue = 0;
  } else {
    const decimalPlacesToRight = [null, undefined].includes(value)
      ? 0
      : value.split('.').length > 1
      ? value.split('.')[1].length
      : 0;

    const newToFixedLength = toFixedLength !== null ? toFixedLength : decimalPlacesToRight;
    parsedValue = ![null, undefined].includes(value) ? parseFloat(value).toFixed(newToFixedLength) : null;
  }

  if (isNaN(parsedValue) || parsedValue === null) return null;

  return parsedValue;
};

/**
 * @func debounce
 * @param {*} func
 * @param {*} wait
 * @param {*} immediate
 */
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export function debounce(func, wait, immediate) {
  var timeout;

  return function executedFunction() {
    var context = this;
    var args = arguments;

    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

/**
 * @func isStupidICatOrCIGOrder
 * @desc this is in place because ICat and CIG order implementation sucks and client IDs were hard codes... this is a quick fix
 * @param {*} clientId
 */
export const isStupidICatOrCIGOrder = clientId => {
  return clientId == 621 || clientId == 622;
};

export const isSmallDevice = () => {
  return window.innerWidth <= 768;
};

export const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
